import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/ClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/IntlProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/ScevClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@bpipartners/webui/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/300.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/400.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/500.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/700.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/material-icons/index.css");
